import { Server } from 'miragejs'
import { DateTime } from 'luxon'

const dt = DateTime.utc(2020, 5, 23, 17, 0)

export function makeServer() {
  const server = new Server({
    routes() {
      this.get('/api/artists', () => {
        return [
          {
            id: 1,
            name: 'DJ Tony',
            timezone: 'Europe/Helsinki',
            utcOffset: 3,
            slotId: null,
            username: 'deejiitony',
            backstageUsername: 'deejiitony',
            countryCode: 'FI',
            available: [
              {
                // 2020-05-23T00:00:00.000Z
                date: DateTime.utc(2020, 5, 23).toISO(),
                from: DateTime.utc(2020, 5, 23, 15, 0).toISO(),
                to: DateTime.utc(2020, 5, 23, 18, 0).toISO(),
              },
            ],
            tags: ['dance', '90s'],
            profileUrl: 'https://slipmat.io/dj-tony/',
            photoUrl:
              'https://media.slipmat.io/media/ajax_uploads/ajax_uploads/29239efa29874a7f9ae07da49fb7dcb3..jpg',
          },
          {
            id: 2,
            name: 'Marky J',
            timezone: 'Europe/London',
            utcOffset: 1,
            slotId: null,
            username: 'DrBones',
            backstageUsername: 'DrBones',
            countryCode: 'GB',
            available: [
              {
                date: DateTime.utc(2020, 5, 23).toISO(),
                from: DateTime.utc(2020, 5, 23, 16, 0).toISO(),
                to: DateTime.utc(2020, 5, 24, 0, 0).toISO(),
              },
            ],
            tags: ['soul', 'northernsoul'],
            profileUrl: 'https://slipmat.io/marky-j/',
            photoUrl:
              'https://media.slipmat.io/media/dj_photos/5a65506d-a602-4c9c-86c5-561252ab1eaa_1585251625.jpg',
          },
          {
            id: 3,
            name: 'digitizedsoul',
            timezone: 'America/Detroit',
            utcOffset: -5,
            slotId: null,
            username: 'digitizedsoul',
            backstageUsername: 'digitizedsoul',
            countryCode: 'US',
            available: [
              {
                date: DateTime.utc(2020, 5, 23).toISO(),
                from: DateTime.utc(2020, 5, 23, 10, 0).toISO(),
                to: DateTime.utc(2020, 5, 24, 0, 0).toISO(),
              },
            ],
            tags: ['uplifting', 'trance'],
            profileUrl: 'https://slipmat.io/digitizedsoul/',
            photoUrl:
              'https://media.slipmat.io/media/dj_photos/6ad02713-6f1c-49d5-ac84-4b782b61fdf6_1582125939.jpg',
          },
          {
            id: 4,
            name: 'DJ Disco Vinnie',
            timezone: 'America/Los_Angeles',
            utcOffset: -8,
            slotId: null,
            username: 'Vinnie',
            backstageUsername: 'DVinnie',
            countryCode: 'US',
            available: [
              {
                date: DateTime.utc(2020, 5, 23).toISO(),
                from: DateTime.utc(2020, 5, 23, 20, 0).toISO(),
                to: DateTime.utc(2020, 5, 23, 23, 0).toISO(),
              },
            ],
            tags: ['70s', 'disco'],
            profileUrl: 'https://slipmat.io/dj-disco-vinnie/',
            photoUrl:
              'https://media.slipmat.io/media/dj_photos/33594450-3af7-49ac-9ade-82df9e7488b5_1584824822.png',
          },
          {
            id: 5,
            name: 'DJ Majesty',
            timezone: 'Asia/Tokyo',
            utcOffset: 9,
            slotId: null,
            username: 'MrGoolsby',
            backstageUsername: 'MrGoolsby',
            countryCode: 'JP',
            available: [
              {
                date: DateTime.utc(2020, 5, 23).toISO(),
                from: DateTime.utc(2020, 5, 23, 4, 0).toISO(),
                to: DateTime.utc(2020, 5, 24, 0, 0).toISO(),
              },
            ],
            tags: ['house', 'electro-house'],
            profileUrl: 'https://slipmat.io/dj-majesty/',
            photoUrl:
              'https://media.slipmat.io/media/dj_photos/31206c79-f2c9-4496-854a-6453e90bb661_1585875690.jpg',
          },
          {
            id: 6,
            name: 'Mapkin DJ',
            timezone: 'Asia/Bangkok',
            utcOffset: 7,
            slotId: null,
            username: 'mapkin',
            backstageUsername: 'mapkin',
            countryCode: 'TH',
            available: [
              {
                date: DateTime.utc(2020, 5, 23).toISO(),
                from: DateTime.utc(2020, 5, 23, 16, 0).toISO(),
                to: DateTime.utc(2020, 5, 24, 0, 0).toISO(),
              },
            ],
            tags: ['rap', 'hiphop'],
            profileUrl: 'https://slipmat.io/mapkindj/',
            photoUrl:
              'https://media.slipmat.io/media/dj_photos/6728d2ad-7676-4bed-a6c0-4e80814ec54c_1561074863.jpg',
          },
          {
            id: 7,
            name: 'DJ Satai',
            timezone: 'Europe/Helsinki',
            utcOffset: 3,
            slotId: null,
            username: 'djsatai',
            backstageUsername: 'djsatai',
            countryCode: 'FI',
            available: [
              {
                // 2020-05-23T00:00:00.000Z
                date: DateTime.utc(2020, 5, 23).toISO(),
                from: DateTime.utc(2020, 5, 23, 12, 0).toISO(),
                to: DateTime.utc(2020, 5, 24, 0, 0).toISO(),
              },
            ],
            tags: ['90s', 'eurodance'],
            profileUrl: 'https://slipmat.io/djsatai/',
            photoUrl:
              'https://media.slipmat.io/media/ajax_uploads/ajax_uploads/613e89b04b8849de895bfe38b2f4e3b8..jpg',
          },
          {
            id: 8,
            name: 'DJ Frohoke',
            timezone: 'Europe/Helsinki',
            utcOffset: 3,
            slotId: null,
            username: 'frohike',
            backstageUsername: 'frohike',
            countryCode: 'FI',
            available: [
              {
                // 2020-05-23T00:00:00.000Z
                date: DateTime.utc(2020, 5, 23).toISO(),
                from: DateTime.utc(2020, 5, 23, 8, 0).toISO(),
                to: DateTime.utc(2020, 5, 24, 0, 0).toISO(),
              },
            ],
            tags: ['industrial', 'retro'],
            profileUrl: 'https://slipmat.io/frohike/',
            photoUrl:
              'https://media.slipmat.io/media/dj_photos/2ddac158-a2a5-49d9-9e54-bbc9a246d004_1570035480.png',
          },
        ]
      })

      this.get('/api/timeslots', () => {
        return [
          {
            id: 1,
            time: dt.toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 2,
            time: dt.plus({ hours: 1 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 15,
            time: dt.plus({ hours: 2 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 3,
            time: dt.plus({ hours: 3 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 4,
            time: dt.plus({ hours: 4 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 5,
            time: dt.plus({ hours: 5 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 6,
            time: dt.plus({ hours: 6 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 7,
            time: dt.plus({ hours: 7 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 8,
            time: dt.plus({ hours: 8 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 9,
            time: dt.plus({ hours: 9 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 10,
            time: dt.plus({ hours: 10 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 11,
            time: dt.plus({ hours: 11 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 12,
            time: dt.plus({ hours: 12 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 13,
            time: dt.plus({ hours: 13 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
          {
            id: 14,
            time: dt.plus({ hours: 14 }).toISO(),
            artistId: null,
            status: 'EMPTY',
          },
        ]
      })
    },
  })
  return server
}
